import React, { useEffect, useState } from 'react'

import { publishEvent } from '@zet/analytics'
import { B2, colors, Stack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import ArrowDown from '@zet/design-system/svg/ArrowDown'
import CalenderOutlined from '@zet/design-system/svg/CalenderOutlined'
import { i18n } from '@zet/localization'
import { timeFilterOptions } from '@zet/utils/Constants'

import { CalenderFilled } from '../../../assests/svg'
import { IDateFilter } from '../../api/types'
import MarkAsSelected from '../earningsFilterTabs/markAsSelected'
import DateOptions from './dateOptions'

const DateFilter = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  screenName,
}: IDateFilter) => {
  const [isBSheetVisible, setIsBSheetVisible] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [filterIndex, setFilterIndex] = useState()
  const [markAsFilterSelected, setMarkAsFilterSelected] = useState(false)
  const [selectedStartDate, setSelectedStartDate] = useState<string>('')
  const [selectedEndDate, setSelectedEndDate] = useState<string>('')

  function handleOpenBSheet() {
    setIsBSheetVisible(true)
    publishEvent('click_action', {
      item_name: 'earnings_subsection_filters',
      feature: 'earnings',
      subsection_name: screenName,
      filter_name: 'time',
    })
  }
  function handleCloseBsheet() {
    setIsBSheetVisible(false)
  }
  function handleOpenDatePicker() {
    setFilterIndex(4)
    setSelectedStartDate('')
    setSelectedEndDate('')
    setIsModalVisible(true)
  }
  function handleDateFilter(filter, index) {
    setSelectedStartDate(filter.startDate)
    setSelectedEndDate(filter.endDate)
    setFilterIndex(index)
  }

  function handleApply() {
    setEndDate(selectedEndDate)
    setStartDate(selectedStartDate)
    handleCloseBsheet()
    setMarkAsFilterSelected(true)
    publishEvent('click_action', {
      item_name: 'earnings_subsection_filters_apply',
      feature: 'earnings',
      subsection_name: screenName,
      filter_name: 'time',
    })
  }

  function handleReset() {
    setStartDate('')
    setEndDate('')
    setSelectedStartDate('')
    setSelectedEndDate('')
    setFilterIndex('')
    handleCloseBsheet()
    setMarkAsFilterSelected(false)
    publishEvent('click_action', {
      item_name: 'earnings_subsection_filters_cancel',
      feature: 'earnings',
      subsection_name: screenName,
      filter_name: 'time',
    })
  }

  useEffect(() => {
    if (!startDate && !endDate) {
      setMarkAsFilterSelected(false)
    }
  }, [startDate, endDate])

  return (
    <Stack className="ml-2 py-2">
      <Pressable
        className="border-grays-40 flex-row items-center rounded border px-2 py-1"
        onPress={handleOpenBSheet}
      >
        {markAsFilterSelected ? <CalenderFilled /> : <CalenderOutlined />}
        <B2 className="text-grays-80 mx-2">{i18n.t('timePeriod')}</B2>
        <ArrowDown color={colors.grays[60]} />
        <DateOptions
          endDate={selectedEndDate}
          filterIndex={filterIndex}
          handleCloseBsheet={handleCloseBsheet}
          handleDateFilter={handleDateFilter}
          handleOpenDatePicker={handleOpenDatePicker}
          isBSheetVisible={isBSheetVisible}
          isModalVisible={isModalVisible}
          setEndDate={setSelectedEndDate}
          setIsModalVisible={setIsModalVisible}
          setStartDate={setSelectedStartDate}
          startDate={selectedStartDate}
          timeFilterOptions={timeFilterOptions}
          handleApply={handleApply}
          handleReset={handleReset}
        />
      </Pressable>
      {markAsFilterSelected && <MarkAsSelected />}
    </Stack>
  )
}

export default DateFilter
